import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArchive: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArchive"><Path d="M20.5 20.5V8.5H3.5V20.5H20.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6 8.5V2.5H10.5L12.5 4.5H18V8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 12.5L11.5 12.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArchive;
